export default {"src":"/_next/static/media/icon-scale.ddaed751.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};